document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".accordion-item");

  accordions.forEach((item) => {
    const btn = item.querySelector(".accordion-button");
    const content = item.querySelector(".accordion-content");

    btn.addEventListener("click", () => {
      content.style.maxHeight =
        content.style.maxHeight ? null : content.scrollHeight + "px";
      item.classList.toggle("open");
    });
  });
});